export const CLEAR_INBOX = '[ Message ] Clear inbox'
export const CREATE_MESSAGE = '[ Message ] Create new message'
export const FETCH_MESSAGES = '[ Message ] Fetch messages'
